export const PRESALE_REQUEST_TYPE_ALIAS = {
  EXISTING_SYSTEM_DEVELOPMENT_COMPLETION: 'EXISTING_SYSTEM_DEVELOPMENT_COMPLETION',
  NEW_CREATION: 'NEW_CREATION',
  MODERNIZATION_OF_OUTDATED: 'MODERNIZATION_OF_OUTDATED',
  EXPANSION_OF_EXISTING_SYSTEM: 'EXPANSION_OF_EXISTING_SYSTEM',
  DEFECT_FIXING: 'DEFECT_FIXING',
  CONTRACT_EXTENSION: 'CONTRACT_EXTENSION',
};

export const APPLICATION_TYPE_ALIAS = {
  WEB: 'WEB',
  MOBILE: 'MOBILE',
};
